import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import LoadingTable from 'Modules/ActionsRewrite/components/LoadingTable';
import LoaderFilterButton from 'Modules/Shared/components/ActionsNewRouteLoader/LoaderFilterButton';
import LoaderSortButton from 'Modules/Shared/components/ActionsNewRouteLoader/LoaderSortButton';
import LoaderSearchInput from 'Modules/Shared/components/ActionsNewRouteLoader/LoaderSearchInput';
import LoaderNewActionButton from 'Modules/Shared/components/ActionsNewRouteLoader/LoaderNewActionButton';

const styles = theme => ({
  actionsPageV2Root: {
    height: '100%',
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: '12px',
    backgroundColor: theme.palette.white,
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: '8px',
    height: '48px',
  },
  headerTextContiner: {
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerLeftContainer: {
    display: 'flex',
    alignItems: 'center',
  },
});

const ActionsNewRouteLoader = ({ classes }) => {
  return (
    <div className={classes.actionsPageV2Root}>
      <div className={classes.headerTextContiner}>
        <Typography variant="h3">My actions</Typography>
      </div>
      <div className={classes.headerContainer}>
        <div className={classes.headerLeftContainer}>
          <LoaderSearchInput />
          <LoaderFilterButton />
          <LoaderSortButton />
        </div>
        <LoaderNewActionButton />
      </div>
      <LoadingTable />
    </div>
  );
};

ActionsNewRouteLoader.displayName = 'ActionsNewRouteLoader';

export default withStyles(styles)(ActionsNewRouteLoader);
